export const appRootId = "app"

export const appHead = {"meta":[{"charset":"utf-8"},{"http-equiv":"X-UA-Compatible","content":"IE=edge"},{"name":"viewport","content":"width=device-width,height=device-height,initial-scale=1.0,user-scalable=0,minimum-scale=1.0,maximum-scale=1.0,viewport-fit=cover"},{"name":"format-detection","content":"telephone=no"},{"name":"description","content":"Maksuni automatisoi kuittien keruun, kulukorvaukset ja kirjanpidon - vähemmän manuaalista työtä, enemmän aikaa olennaiseen."},{"name":"og:type","property":"og:type","content":"website"},{"name":"og:url","property":"og:url","content":"https://maksuni.fi"},{"name":"og:site_name","property":"og:site_name","content":"maksuni.fi"},{"name":"og:title","property":"og:title","content":"Maksuni.fi | Kuittien hallinta, kulukorvaukset ja kirjanpitoautomaatio"},{"name":"og:description","property":"og:description","content":"Maksuni automatisoi kuittien keruun, kulukorvaukset ja kirjanpidon - vähemmän manuaalista työtä, enemmän aikaa olennaiseen."},{"name":"og:image","property":"og:image","content":"https://maksuni.fi/media/default-og-image.jpg"},{"name":"twitter:card","content":"summary_large_image"},{"name":"twitter:image","content":"https://maksuni.fi/media/default-og-image.jpg"},{"name":"msapplication-TileColor","content":"#ffffff"},{"name":"theme-color","content":"#ffffff"},{"name":"mobile-web-app-capable","content":"yes"},{"name":"apple-mobile-web-app-title","content":"maksuni.fi"}],"link":[{"rel":"canonical","href":"https://maksuni.fi"},{"rel":"icon","type":"image/x-icon","href":"/favicon.ico"},{"rel":"apple-touch-icon","sizes":"180x180","href":"/favicon-180x180.png"},{"rel":"icon","type":"image/png","sizes":"32x32","href":"/favicon-32x32.png"},{"rel":"icon","type":"image/png","sizes":"16x16","href":"/favicon-16x16.png"},{"rel":"manifest","href":"/site.webmanifest"}],"style":[],"script":[{"async":true,"src":"https://accounts.google.com/gsi/client"},{"async":true,"src":"https://www.googletagmanager.com/gtag/js?id=G-S5YF9X3T41"},{"type":"text/javascript","innerHTML":"\n            window.dataLayer = window.dataLayer || [];\n            function gtag(){dataLayer.push(arguments);}\n            gtag('js', new Date());\n            gtag('config', 'G-S5YF9X3T41');"}],"noscript":[],"title":"Maksuni.fi | Kuittien hallinta, kulukorvaukset ja kirjanpitoautomaatio","titleTemplate":"%s | Maksuni.fi","htmlAttrs":{"lang":"fi-FI","dir":"ltr"},"bodyAttrs":{"class":"antialiased min-h-screen relative overflow-x-hidden"}}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootTag = "div"

export const appRootAttrs = {"id":"app","class":"isolate"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const appSpaLoaderTag = "div"

export const appSpaLoaderAttrs = {"id":"__nuxt-loader"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"deep":false}

export const resetAsyncDataToUndefined = false

export const nuxtDefaultErrorValue = undefined

export const fetchDefaults = {}

export const vueAppRootContainer = '#app'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = false

export const spaLoadingTemplateOutside = true

export const purgeCachedData = true

export const granularCachedData = true

export const pendingWhenIdle = false

export const alwaysRunFetchOnKeyChange = false